import { render, staticRenderFns } from "./TokenSetting.vue?vue&type=template&id=6edeeb43&scoped=true"
import script from "./TokenSetting.vue?vue&type=script&lang=js"
export * from "./TokenSetting.vue?vue&type=script&lang=js"
import style0 from "./TokenSetting.vue?vue&type=style&index=0&id=6edeeb43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edeeb43",
  null
  
)

export default component.exports